// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../css-loader/dist/cjs.js??ref--3-oneOf-1-1!../../../../../../../vue-loader/lib/loaders/stylePostLoader.js!../../../../../../../postcss-loader/src/index.js??ref--3-oneOf-1-2!../../../../../../../@nuxt/components/dist/loader.js??ref--0-0!../../../../../../../vue-loader/lib/index.js??vue-loader-options!./NsPopup.vue?vue&type=style&index=0&id=15528344&scoped=true&lang=css&");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../../../../../vue-style-loader/lib/addStylesClient.js").default
var update = add("6c169dc0", content, true, {"sourceMap":false});